import { z } from 'zod';
import { SBranch } from '@/src/modules/branch/data/schemas/responses/branch';
import { createStandardResponse } from '@/src/shared/data/schemas/responses/base';

export const SChatAccount = z.object({
  id: z.number(),
  account_id: z.number(),
  branch: SBranch,
  pubsub_token: z.string(),
});
export type TChatAccount = z.infer<typeof SChatAccount>;

export const SChatAccountResponse = createStandardResponse(SChatAccount);
export type TChatAccountResponse = z.infer<typeof SChatAccountResponse>;
